import { render, staticRenderFns } from "./notice_details.vue?vue&type=template&id=651dc382&scoped=true"
import script from "./notice_details.vue?vue&type=script&lang=js"
export * from "./notice_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651dc382",
  null
  
)

export default component.exports